import { StateCreator } from "zustand";

export interface EarthlightMapViewState {
    isVisible: boolean;
    top: number;
    left: number;
    width: number;
    height: number;
    ready: boolean;
}

export interface EarthlightMapViewSlice {
    earthlightMapView: EarthlightMapViewState;
    setEarthlightMapView: (state: EarthlightMapViewState) => void;
    updateEarthlightMapView: (partialState: Partial<EarthlightMapViewState>) => void;
    showEarthlightMapView: (top: number, left: number, width: number, height: number) => void;
    hideEarthlightMapView: () => void;
}

const initialEarthlightMapViewState: EarthlightMapViewState = {
    ready: false,
    isVisible: false,
    top: -1,
    left: -1,
    width: 1,
    height: 1,
};

export const createEarthlightMapViewSlice: StateCreator<EarthlightMapViewSlice, [], [], EarthlightMapViewSlice> = (set) => ({
    earthlightMapView: initialEarthlightMapViewState,

    setEarthlightMapView: (state) => set({ earthlightMapView: state }),
    updateEarthlightMapView: (partialState) => set((state) => ({ earthlightMapView: { ...state.earthlightMapView, ...partialState } })),
    showEarthlightMapView: (top, left, width, height) =>
        set((state) => ({ earthlightMapView: { ...state.earthlightMapView, isVisible: true, top, left, width, height } })),
    hideEarthlightMapView: () => set((state) => ({ earthlightMapView: { ...state.earthlightMapView, isVisible: false } })),
});

